import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { registerGuestStepMismatchHandler } from "../services/http";
import { guestEnrollmentPathFromStep } from "./guestEnrollmentFlow";

const GUEST_PATH_PREFIX = "/guest-user";

/**
 * Central handler for API responses with statusCode 417 (guest enrollment step mismatch).
 * Shows the server message, then navigates to the step in `data.currentStep`.
 */
export default function GuestEnrollmentStepMismatchHost() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [messageText, setMessageText] = useState("");
  const payloadRef = useRef(null);

  useEffect(() => {
    registerGuestStepMismatchHandler((payload) => {
      if (!window.location.pathname.startsWith(GUEST_PATH_PREFIX)) return;

      const msg =
        typeof payload?.message === "string" && payload.message.trim()
          ? payload.message
          : "Please follow the enrollment steps.";

      payloadRef.current = payload;
      setMessageText(msg);
      setOpen(true);
    });

    return () => registerGuestStepMismatchHandler(null);
  }, []);

  const handleContinue = () => {
    const payload = payloadRef.current;
    payloadRef.current = null;
    setOpen(false);
    const path = guestEnrollmentPathFromStep(payload?.data?.currentStep);
    navigate(path, { replace: true });
  };

  return (
    <Modal
      className="custom-modal responsiveModal text-center"
      open={open}
      onCancel={handleContinue}
      footer={null}
      closeIcon={null}
      centered
      maskClosable={false}
      keyboard={false}
    >
      <div className="tgb fs-20 lh-25 mb-40 text-center">{messageText}</div>
      <div className="text-center">
        <button
          type="button"
          className="saveBtn cursor-pointer"
          onClick={handleContinue}
        >
          {t("Continue")}
        </button>
      </div>
    </Modal>
  );
}
